// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultStaffPersonaPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};

const defaultStaffPersonaFilter = {
	$skip: defaultStaffPersonaPagination.$skip,
	$limit: defaultStaffPersonaPagination.$limit,
};

export default {
	namespaced: true,
	state: {
		staffPersonaList: [],
		skillsList: [],
		tagsList: [],
		searchPersonaList: [],
		personaDirectSkills: [],
		personaTags: [],
		staffPersonaFilter: defaultStaffPersonaFilter,
		staffPersonaPagination: defaultStaffPersonaPagination,
	},
	getters: {
		getStaffPersonaList: (state) => state.staffPersonaList,
		getStaffPersonaSkills: (state) => state.skillsList,
		getStaffPersonaTags: (state) => state.tagsList,
		getSearchPersona: (state) => state.searchPersonaList,
		getPersonaDirectSkills: (state) => state.personaDirectSkills,
		staffPersonaPage: (state) => {
			const { $limit, $skip } = state.staffPersonaPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_STAFF_PERSONA: (state, payload) => {
			state.staffPersonaList = payload;
		},
		SET_STAFF_PERSONA_SKILLS: (state, payload) => {
			state.skillsList = payload;
		},
		SET_STAFF_PERSONA_TAGS: (state, payload) => {
			state.tagsList = payload;
		},
		SET_SEARCH_PERSONA_TAGS: (state, payload) => {
			state.searchPersonaList = payload;
		},
		SET_PERSONA_DIRECT_SKILLS: (state, payload) => {
			state.personaDirectSkills = payload;
		},
		SET_PERSONA_TAGS: (state, payload) => {
			state.personaTags = payload;
		},
		SET_STAFF_PERSONA_FILTER: (state, filter) => { state.staffPersonaFilter = { ...state.staffPersonaFilter, ...filter }; },
		SET_DEFAULT_STAFF_PERSONA_FILTER: (state, filter) => { state.staffPersonaFilter = { ...filter, ...defaultStaffPersonaFilter }; },
		SET_STAFF_PERSONA_PAGINATION: (state, data) => { state.staffPersonaPagination = { ...state.staffPersonaPagination, ...data }; },
	},
	actions: {
		setStaffPersonaFilter: ({ commit }, filter) => {
			commit('SET_STAFF_PERSONA_FILTER', filter);
		},
		setDefaultStaffPersonaFilter: ({ commit }, filter) => {
			commit('SET_DEFAULT_STAFF_PERSONA_FILTER', filter);
		},
		setStaffPersonaPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.staffPersonaPagination.$limit;
			commit('SET_STAFF_PERSONA_PAGINATION', { $skip });
			commit('SET_STAFF_PERSONA_FILTER', { $skip });
		},
		addStaffPersona: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).create(data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		updateStaffPersona: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonas/';
			const results = await feathersClient.service(url).patch(data.id, data, { query: { $role: rootGetters.currentUserRole } });
			return results;
		},
		loadAddExpertLevelOptions: async ({ rootGetters }) => {
			const url = '/api/v3/skillexpertleveltags';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole,
					$paginate: false,
				},
			});
			return results;
		},
		loadStaffPersona: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, fields: ['owner'], ...filter } });
			commit('SET_STAFF_PERSONA', results.data);
			commit('SET_STAFF_PERSONA_PAGINATION', { total: results.total });
			return results;
		},
		searchLoadSkills: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/skills';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, $paginate: false, ...filter } });
			commit('SET_STAFF_PERSONA_SKILLS', results);
			return results;
		},
		searchLoadTags: async ({ commit, rootGetters }, filter) => {
			const url = '/api/v3/skillgroupingtags';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole, $paginate: false, fields: [], ...filter,
				},
			});
			commit('SET_STAFF_PERSONA_TAGS', results);
			return results;
		},
		loadSkillsForPersona: async({ rootGetters }, personaId) => {
			const url = '/api/v3/getstaffpersonaskills';
			const results = await feathersClient.service(url).find({ query: { personaId: personaId, $role: rootGetters.currentUserRole } });
			return results;
		},
		searchLoadPersona: async ({ rootGetters, commit }, filter) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).find({
				query: {
					$role: rootGetters.currentUserRole, $paginate: false, ...filter,
				},
			});
			commit('SET_SEARCH_PERSONA_TAGS', results);
			return results;
		},
		loadTagExpertLevelSkills: async ({ rootGetters }, query) => {
			const url = '/api/v3/gettagexpertlevelskills';
			const results = await feathersClient.service(url).find({ query: { $role: rootGetters.currentUserRole, ...query } });
			return results;
		},
		getStaffPersonaById: async ({ rootGetters }, data) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).get(data.id, {
				query: {
					fields: [ 'owner', 'directSkills', 'groupExpertCombination', 'childPersona'],
					$role: rootGetters.currentUserRole,
				},
			});
			return results;
		},
		deleteChildPersonas: async ({ rootGetters }, filter) => {
			const url = '/api/v3/childpersonas';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deleteGroupExpertCombinations: async ({ rootGetters }, filter) => {
			const url = '/api/v3/groupexpertcombinations';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deletePersonaDirectSkills: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonadirectskills';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
		deletePersonas: async ({ rootGetters }, filter) => {
			const url = '/api/v3/staffpersonas';
			const results = await feathersClient.service(url).remove(null, { query: { $role: rootGetters.currentUserRole, ...filter } });
			return results;
		},
	},
};
